import moment from 'moment';
import { DATE_FORMAT } from '../constants/app.constants';

const getDuration = (startDate, endDate, format = DATE_FORMAT, unit = 'days') => {
  if (typeof startDate === 'string') {
    startDate = moment(startDate, format);
  }
  if (typeof endDate === 'string') {
    endDate = moment(endDate, format);
  }
  return endDate.diff(startDate, unit);
}

const convertDateFormat = (date, to = DATE_FORMAT) => {
  return moment(date).format(to);
}

const isDateFormatCorrect = (date, separator) => {
  const regex = new RegExp(`^\\d{2}\\${separator}\\d{2}\\${separator}\\d{4}`);
  return regex.test(date);
}

/**
 * 
 * @param {*} date 
 * @returns format: DD MMM YYYY HH:mm. For example: 01 Jan 2021 12:00
 */
const toDayMonthYearTimeFormat = (date) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  let dateObj;

  if (typeof date === "string" && date.includes("/")) {
    const [datePart, timePart] = date.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours = 0, minutes = 0, seconds = 0] = timePart?.split(":").map(Number) || [];
    dateObj = new Date(year, month - 1, day, hours, minutes, seconds);
  } else {
    dateObj = new Date(date);
  }

  const day = dateObj.getDate();
  const month = months[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  return `${day} ${month} ${year} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
};
function isDatePickerFormat(date) {
  const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
  return pattern.test(date);
}

function converToDateFormat(date) {
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
}

const isDate = (dateString) => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

const dateUtils = {
  getDuration,
  convertDateFormat,
  isDateFormatCorrect,
  toDayMonthYearTimeFormat,
  isDatePickerFormat,
  converToDateFormat,
  isDate
};

export default dateUtils;